// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"04a1e5fc","453":"4a70f96c"}[chunkId] + ".chunk.js";
};